import { MenuLateral } from '../components/MenuLateral';
import { MenuSuperior } from '../components/MenuSuperior';
import { Conteiner, ConteinerMenuLateral } from './styles';

function AuthenticatedRoute({ children }) {
  return (
    <>
      <MenuSuperior />
      <Conteiner>
        <ConteinerMenuLateral>
          <MenuLateral />
        </ConteinerMenuLateral>
        {children}
      </Conteiner>
    </>
  );
}

export default AuthenticatedRoute;
